import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray } from '@angular/forms';
import { SurveyQuestion } from '../../Models/Survey';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'survey-question',
    templateUrl: './survey-question.component.html',
    styleUrls: ['./survey-question.component.scss']
})

export class SurveyQuestionComponent implements OnInit {
    myForm: FormGroup;
    constructor(private _fb: FormBuilder, private dialogRef: MatDialogRef<SurveyQuestionComponent>) { }

    ngOnInit() {
        this.myForm = this._fb.group({
            SurveyQuestionID: 0,
            QuestionTitle: '',
            SurveyQuestionTypeID: undefined,
            SurveyQuestionOptions: this._fb.array([this.createOption(), this.createOption()])
        });
    }

    createOption(): FormGroup {
        return this._fb.group({
            SurveyQuestionOptionID: 0,
            OptionValue: undefined,
        });
        
    }

    addOption(): void {
        const SurveyQuestionOptions: FormArray = this.myForm.get('SurveyQuestionOptions') as FormArray;
        SurveyQuestionOptions.push(this.createOption());
    }

    onQuestionTypeChange(e) {
        if (e.value === 3) {
            while (this.myForm.controls.SurveyQuestionOptions['length'] !== 0) {
                this.myForm.controls.SurveyQuestionOptions['removeAt'](0);
            }
        } else {
            while (this.myForm.controls.SurveyQuestionOptions['length'] < 2) {
                this.addOption();
            }
        }
    }

    cearNullOrEmpty(question: SurveyQuestion): SurveyQuestion {
        question.SurveyQuestionOptions = question.SurveyQuestionOptions.filter(option => {
            return (option.OptionValue !== null && option.OptionValue.trim() !== '');
        });
        return question;
    }

    submit() {
        if (!this.myForm.valid) { return; }
        let question: SurveyQuestion = this.myForm.value;
        switch (question.SurveyQuestionTypeID) {
            case 1: question.SurveyQuestionType = 'Radio List';
                question = this.cearNullOrEmpty(question);
                break;
            case 2: question.SurveyQuestionType = 'Checkbox List';
                question = this.cearNullOrEmpty(question);
                break;
            case 3: question.SurveyQuestionType = 'TextBox';
                question.SurveyQuestionOptions = [];
                break;
        }

        this.dialogRef.close(question);
    }
}